export interface Chapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
  views: number;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  coverLarge: string;
  description: string;
  categories: string[];
  chapters: Chapter[];
  status: string;
  views: number;
  rating: number;
  updatedAt: string;
  tags: string[];
}

export const allComics: Comic[] = [
  {
    id: 1,
    title: "剑尊归来",
    author: "REDICE STUDIO",
    cover: "https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20webtoon%20cover%20illustration%20featuring%20a%20martial%20artist%20with%20a%20sword%20in%20dramatic%20dynamic%20pose%2C%20dark%20moody%20atmosphere%20with%20warm%20amber%20accents%2C%20clean%20composition%20on%20simple%20dark%20background%2C%20high%20contrast%2C%20illustration%20style&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=Epic%20Korean%20webtoon%20banner%20featuring%20a%20lone%20swordsman%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20mountainous%20landscape%2C%20dramatic%20sunset%20lighting%20with%20warm%20orange%20and%20dark%20shadows%2C%20cinematic%20composition%2C%20illustration%20style%20with%20clean%20lines%2C%20dark%20moody%20atmosphere&width=1200&height=600&seq=comic-hero-01&orientation=landscape",
    description: "一代剑尊陨落之后，竟重生回到少年时代。带着前世的记忆与剑术，他誓要改变命运，重登武道巅峰！曾经的敌人、背叛的挚友、错过的爱人……这一世，他不会再让任何遗憾发生。",
    categories: ["热血", "玄幻"],
    chapters: [
      { id: 101, title: "第1话 重生", number: 1, updatedAt: "2026-08-01", views: 158000 },
      { id: 102, title: "第2话 宿命", number: 2, updatedAt: "2026-07-30", views: 142000 },
      { id: 103, title: "第3话 觉醒", number: 3, updatedAt: "2026-07-28", views: 135000 },
      { id: 104, title: "第4话 试炼", number: 4, updatedAt: "2026-07-25", views: 128000 },
      { id: 105, title: "第5话 破境", number: 5, updatedAt: "2026-07-22", views: 121000 },
      { id: 106, title: "第6话 归来", number: 6, updatedAt: "2026-07-20", views: 115000 },
      { id: 107, title: "第7话 对决", number: 7, updatedAt: "2026-07-18", views: 108000 },
      { id: 108, title: "第8话 突破", number: 8, updatedAt: "2026-07-15", views: 102000 },
    ],
    status: "连载中",
    views: 1580000,
    rating: 9.6,
    updatedAt: "2026-08-01",
    tags: ["重生", "剑术", "热血", "逆袭"],
  },
  {
    id: 2,
    title: "全知读者视角",
    author: "SINGNSONG",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20Korean%20webtoon%20cover%20with%20a%20young%20man%20holding%20a%20glowing%20book%20surrounded%20by%20floating%20text%20panels%2C%20dark%20mysterious%20atmosphere%20with%20subtle%20golden%20light%2C%20clean%20composition%20on%20simple%20dark%20background%2C%20illustration%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20webtoon%20banner%20scene%20showing%20a%20young%20reader%20surrounded%20by%20floating%20pages%20and%20glowing%20text%20in%20a%20dark%20library%2C%20cinematic%20lighting%20with%20golden%20accents%2C%20illustration%20style%2C%20dreamy%20atmosphere&width=1200&height=600&seq=comic-hero-02&orientation=landscape",
    description: "平凡上班族金独子，十年来唯一追读的小说《灭活法》迎来了最终话。就在小说完结的那一刻，世界发生了翻天覆地的变化——小说中的末日场景竟在现实中上演！作为唯一知道剧情走向的人，他的生存之旅开始了。",
    categories: ["奇幻", "悬疑"],
    chapters: [
      { id: 201, title: "第1话 最终话", number: 1, updatedAt: "2026-08-03", views: 189000 },
      { id: 202, title: "第2话 幸存者", number: 2, updatedAt: "2026-08-01", views: 176000 },
      { id: 203, title: "第3话 剧本", number: 3, updatedAt: "2026-07-29", views: 168000 },
      { id: 204, title: "第4话 同行者", number: 4, updatedAt: "2026-07-26", views: 155000 },
      { id: 205, title: "第5话 星流", number: 5, updatedAt: "2026-07-23", views: 148000 },
      { id: 206, title: "第6话 化身", number: 6, updatedAt: "2026-07-20", views: 139000 },
    ],
    status: "连载中",
    views: 2100000,
    rating: 9.8,
    updatedAt: "2026-08-03",
    tags: ["末世", "小说", "生存", "悬疑"],
  },
  {
    id: 3,
    title: "我独自升级",
    author: "CHUGONG",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20webtoon%20cover%20showing%20a%20powerful%20hunter%20with%20glowing%20purple%20eyes%20and%20shadow%20soldiers%20behind%20him%2C%20intense%20atmosphere%20with%20dark%20tones%2C%20clean%20composition%20on%20simple%20dark%20background%2C%20illustration%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=Epic%20Korean%20webtoon%20scene%20of%20a%20lone%20hunter%20commanding%20an%20army%20of%20shadows%20in%20a%20dark%20dungeon%2C%20dramatic%20lighting%20with%20purple%20and%20blue%20glowing%20effects%2C%20cinematic%20composition%2C%20illustration%20style&width=1200&height=600&seq=comic-hero-03&orientation=landscape",
    description: "十年前，世界突然出现了连接异次元的「门」，觉醒者们成为了猎魔人。成振宇作为E级猎人，被称作「人类最弱」，却在一次双重地下城事故后，获得了神秘的系统——「只有我才能看到的升级任务」。",
    categories: ["热血", "奇幻"],
    chapters: [
      { id: 301, title: "第1话 最弱猎人", number: 1, updatedAt: "2026-08-02", views: 220000 },
      { id: 302, title: "第2话 双重地下城", number: 2, updatedAt: "2026-07-31", views: 210000 },
      { id: 303, title: "第3话 系统激活", number: 3, updatedAt: "2026-07-28", views: 198000 },
      { id: 304, title: "第4话 每日任务", number: 4, updatedAt: "2026-07-25", views: 185000 },
      { id: 305, title: "第5话 实力提升", number: 5, updatedAt: "2026-07-22", views: 176000 },
      { id: 306, title: "第6话 地下城突袭", number: 6, updatedAt: "2026-07-19", views: 168000 },
      { id: 307, title: "第7话 觉醒", number: 7, updatedAt: "2026-07-16", views: 155000 },
    ],
    status: "已完结",
    views: 5200000,
    rating: 9.9,
    updatedAt: "2026-08-02",
    tags: ["升级", "系统", "猎人", "暗影"],
  },
  {
    id: 4,
    title: "反派千金",
    author: "SUMIRE",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20webtoon%20cover%20featuring%20an%20elegant%20noblewoman%20in%20a%20lavish%20Victorian%20dress%20with%20a%20mysterious%20smile%2C%20soft%20romantic%20lighting%2C%20clean%20composition%20on%20simple%20warm%20background%2C%20illustration%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=Elegant%20Korean%20romance%20webtoon%20scene%20of%20a%20noble%20ballroom%20with%20chandeliers%20and%20dancing%20couples%2C%20a%20villainess%20standing%20proudly%20in%20the%20center%2C%20soft%20golden%20lighting%2C%20romantic%20atmosphere%2C%20illustration%20style&width=1200&height=600&seq=comic-hero-04&orientation=landscape",
    description: "醒来发现自己变成了小说中的反派千金——注定要被主角处刑的恶役！为了改变悲剧结局，她决定远离主角、低调行事。然而，越是想要避开，命运的齿轮却越是向她靠拢……",
    categories: ["恋爱", "奇幻"],
    chapters: [
      { id: 401, title: "第1话 转生", number: 1, updatedAt: "2026-08-01", views: 135000 },
      { id: 402, title: "第2话 社交季", number: 2, updatedAt: "2026-07-29", views: 128000 },
      { id: 403, title: "第3话 意外邂逅", number: 3, updatedAt: "2026-07-26", views: 120000 },
      { id: 404, title: "第4话 茶会风波", number: 4, updatedAt: "2026-07-23", views: 112000 },
      { id: 405, title: "第5话 命运的齿轮", number: 5, updatedAt: "2026-07-20", views: 105000 },
    ],
    status: "连载中",
    views: 890000,
    rating: 9.3,
    updatedAt: "2026-08-01",
    tags: ["转生", "恶役", "浪漫", "贵族"],
  },
  {
    id: 5,
    title: "神之塔",
    author: "SIU",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20fantasy%20webtoon%20cover%20showing%20a%20boy%20climbing%20a%20massive%20tower%20with%20various%20floors%20visible%2C%20dark%20atmospheric%20with%20ethereal%20light%20from%20above%2C%20clean%20composition%20on%20simple%20dark%20background%2C%20illustration%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20massive%20mysterious%20tower%20rising%20into%20the%20sky%20with%20adventurers%20climbing%20its%20floors%2C%20Korean%20webtoon%20fantasy%20style%2C%20epic%20scale%2C%20dramatic%20lighting%20from%20above%2C%20dark%20atmosphere%20with%20warm%20accents%2C%20illustration&width=1200&height=600&seq=comic-hero-05&orientation=landscape",
    description: "传说中的神之塔，据说登顶者可以实现任何愿望。少年夜为了追寻唯一的挚友蕾哈尔，踏上了攀登神之塔的旅程。每一层都是不同的世界，每一次试炼都是生死的考验。",
    categories: ["奇幻", "冒险"],
    chapters: [
      { id: 501, title: "第1话 塔之门", number: 1, updatedAt: "2026-07-30", views: 198000 },
      { id: 502, title: "第2话 第一层", number: 2, updatedAt: "2026-07-27", views: 185000 },
      { id: 503, title: "第3话 试炼开始", number: 3, updatedAt: "2026-07-24", views: 172000 },
      { id: 504, title: "第4话 竞争者", number: 4, updatedAt: "2026-07-21", views: 160000 },
      { id: 505, title: "第5话 王冠游戏", number: 5, updatedAt: "2026-07-18", views: 151000 },
    ],
    status: "连载中",
    views: 3800000,
    rating: 9.5,
    updatedAt: "2026-07-30",
    tags: ["塔", "冒险", "愿望", "试炼"],
  },
  {
    id: 6,
    title: "甜蜜的陷阱",
    author: "PARK EUNHYE",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20Korean%20romance%20webtoon%20cover%20featuring%20a%20charming%20couple%20in%20a%20cozy%20cafe%20setting%2C%20warm%20and%20sweet%20atmosphere%20with%20soft%20lighting%2C%20clean%20composition%20on%20simple%20warm%20background%2C%20illustration%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20warm%20romantic%20Korean%20webtoon%20scene%20of%20a%20couple%20sharing%20a%20sweet%20moment%20in%20a%20sunlit%20cafe%2C%20soft%20golden%20hour%20lighting%2C%20cozy%20atmosphere%20with%20pastries%20and%20coffee%2C%20illustration%20style&width=1200&height=600&seq=comic-hero-06&orientation=landscape",
    description: "甜品师韩素希开了一家小小的甜品店，生活平静而美好。直到那个雨夜，浑身是伤的财阀继承人闯入了她的世界。甜品的甜蜜与危险的漩涡，她到底该如何选择？",
    categories: ["恋爱", "都市"],
    chapters: [
      { id: 601, title: "第1话 雨夜来客", number: 1, updatedAt: "2026-07-31", views: 98000 },
      { id: 602, title: "第2话 甜蜜的邂逅", number: 2, updatedAt: "2026-07-28", views: 92000 },
      { id: 603, title: "第3话 危险的温柔", number: 3, updatedAt: "2026-07-25", views: 85000 },
      { id: 604, title: "第4话 心动警报", number: 4, updatedAt: "2026-07-22", views: 78000 },
    ],
    status: "连载中",
    views: 560000,
    rating: 9.1,
    updatedAt: "2026-07-31",
    tags: ["甜品", "财阀", "浪漫", "都市"],
  },
  {
    id: 7,
    title: "武道至尊",
    author: "LEE HYUN",
    cover: "https://readdy.ai/api/search-image?query=A%20powerful%20Korean%20martial%20arts%20webtoon%20cover%20showing%20a%20warrior%20with%20glowing%20fists%20in%20a%20fighting%20stance%2C%20intense%20dynamic%20pose%2C%20dark%20atmosphere%20with%20warm%20amber%20energy%2C%20clean%20composition%20on%20simple%20dark%20background%2C%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=An%20intense%20Korean%20martial%20arts%20webtoon%20scene%20of%20two%20masters%20facing%20off%20in%20a%20traditional%20training%20ground%2C%20dramatic%20dust%20and%20energy%20effects%2C%20warm%20amber%20lighting%2C%20cinematic%20composition%2C%20illustration%20style&width=1200&height=600&seq=comic-hero-07&orientation=landscape",
    description: "在一个武道为尊的世界，少年林风出身卑微，却怀揣着成为最强武者的梦想。机缘巧合之下，他获得了上古武道传承，从此逆天改命，横扫八方！",
    categories: ["热血", "玄幻"],
    chapters: [
      { id: 701, title: "第1话 武道世界", number: 1, updatedAt: "2026-08-02", views: 125000 },
      { id: 702, title: "第2话 传承", number: 2, updatedAt: "2026-07-30", views: 118000 },
      { id: 703, title: "第3话 初露锋芒", number: 3, updatedAt: "2026-07-27", views: 110000 },
      { id: 704, title: "第4话 宗门大比", number: 4, updatedAt: "2026-07-24", views: 102000 },
    ],
    status: "连载中",
    views: 720000,
    rating: 9.4,
    updatedAt: "2026-08-02",
    tags: ["武道", "传承", "逆袭", "玄幻"],
  },
  {
    id: 8,
    title: "秘密的教室",
    author: "KIM JIYEON",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20thriller%20webtoon%20cover%20showing%20a%20high%20school%20classroom%20with%20eerie%20shadows%20and%20a%20single%20student%20looking%20back%2C%20dark%20suspenseful%20atmosphere%2C%20clean%20composition%20on%20simple%20dark%20background%2C%20illustration&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20creepy%20Korean%20thriller%20webtoon%20scene%20of%20an%20empty%20school%20corridor%20at%20night%20with%20flickering%20lights%20and%20mysterious%20shadows%2C%20dark%20suspenseful%20atmosphere%2C%20cinematic%20composition%2C%20illustration%20style&width=1200&height=600&seq=comic-hero-08&orientation=landscape",
    description: "转学生李贤宇发现，班上的同学们似乎隐藏着一个不能说的秘密。每当夜幕降临，教室中会传出奇怪的声音。好奇心驱使他一步步揭开真相，却不知自己已深陷危险之中……",
    categories: ["悬疑", "惊悚"],
    chapters: [
      { id: 801, title: "第1话 转学生", number: 1, updatedAt: "2026-07-29", views: 105000 },
      { id: 802, title: "第2话 异样的班级", number: 2, updatedAt: "2026-07-26", views: 98000 },
      { id: 803, title: "第3话 深夜的教室", number: 3, updatedAt: "2026-07-23", views: 92000 },
      { id: 804, title: "第4话 第一滴血", number: 4, updatedAt: "2026-07-20", views: 85000 },
    ],
    status: "连载中",
    views: 480000,
    rating: 9.0,
    updatedAt: "2026-07-29",
    tags: ["校园", "悬疑", "秘密", "惊悚"],
  },
  {
    id: 9,
    title: "公爵夫人的下午茶",
    author: "HAN SOMI",
    cover: "https://readdy.ai/api/search-image?query=A%20charming%20Korean%20fantasy%20romance%20webtoon%20cover%20showing%20a%20duchess%20enjoying%20tea%20in%20a%20beautiful%20garden%20with%20roses%2C%20soft%20dreamy%20lighting%2C%20clean%20composition%20on%20simple%20warm%20background%2C%20illustration%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20scene%20of%20a%20duchess%20hosting%20an%20elegant%20tea%20party%20in%20a%20rose%20garden%2C%20soft%20romantic%20lighting%20with%20pastel%20tones%2C%20whimsical%20atmosphere%2C%20illustration%20style&width=1200&height=600&seq=comic-hero-09&orientation=landscape",
    description: "公爵夫人艾琳娜表面上过着人人羡慕的生活，但实际上她的婚姻只是一纸契约。直到她在下午茶会上遇见了一位神秘的园艺师，平静的生活开始泛起涟漪……",
    categories: ["恋爱", "奇幻"],
    chapters: [
      { id: 901, title: "第1话 契约婚姻", number: 1, updatedAt: "2026-07-28", views: 88000 },
      { id: 902, title: "第2话 花园邂逅", number: 2, updatedAt: "2026-07-25", views: 82000 },
      { id: 903, title: "第3话 秘密花园", number: 3, updatedAt: "2026-07-22", views: 76000 },
    ],
    status: "连载中",
    views: 420000,
    rating: 9.2,
    updatedAt: "2026-07-28",
    tags: ["贵族", "契约", "浪漫", "花园"],
  },
  {
    id: 10,
    title: "猎魔人崛起",
    author: "PARK GUN",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20webtoon%20cover%20showing%20a%20demon%20hunter%20with%20a%20massive%20weapon%20facing%20monsters%2C%20intense%20action%20pose%2C%20dark%20atmosphere%20with%20red%20flame%20accents%2C%20clean%20composition%20on%20simple%20dark%20background%2C%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=An%20epic%20Korean%20webtoon%20scene%20of%20a%20demon%20hunter%20battling%20massive%20shadow%20creatures%20in%20a%20burning%20city%2C%20dramatic%20fire%20and%20darkness%20contrast%2C%20cinematic%20composition%2C%20illustration%20style&width=1200&height=600&seq=comic-hero-10&orientation=landscape",
    description: "恶魔入侵人间，人类文明危在旦夕。普通高中生金泰浩在偶然间觉醒了猎魔人血脉，从此踏上狩猎恶魔的道路。从菜鸟到最强，他的传奇由此开始！",
    categories: ["热血", "奇幻"],
    chapters: [
      { id: 1001, title: "第1话 末日降临", number: 1, updatedAt: "2026-08-03", views: 145000 },
      { id: 1002, title: "第2话 血脉觉醒", number: 2, updatedAt: "2026-07-31", views: 135000 },
      { id: 1003, title: "第3话 首战", number: 3, updatedAt: "2026-07-28", views: 128000 },
      { id: 1004, title: "第4话 猎魔人公会", number: 4, updatedAt: "2026-07-25", views: 120000 },
    ],
    status: "连载中",
    views: 650000,
    rating: 9.3,
    updatedAt: "2026-08-03",
    tags: ["恶魔", "猎人", "觉醒", "战斗"],
  },
  {
    id: 11,
    title: "甜蜜暴击",
    author: "CHOI YUNA",
    cover: "https://readdy.ai/api/search-image?query=A%20colorful%20Korean%20romantic%20comedy%20webtoon%20cover%20showing%20a%20cheerful%20couple%20in%20a%20university%20campus%20setting%2C%20bright%20and%20playful%20atmosphere%2C%20clean%20composition%20on%20simple%20light%20background%2C%20illustration%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20fun%20Korean%20romantic%20comedy%20webtoon%20scene%20of%20university%20students%20enjoying%20a%20spring%20festival%20on%20campus%2C%20cherry%20blossoms%2C%20bright%20cheerful%20lighting%2C%20playful%20atmosphere%2C%20illustration%20style&width=1200&height=600&seq=comic-hero-11&orientation=landscape",
    description: "拳击少女尹智秀不小心揍了校草一拳，从此两人的命运纠缠在一起。一个是暴躁直率的运动系少女，一个是腹黑温柔的完美男神，这场校园恋爱喜剧让人捧腹！",
    categories: ["恋爱", "校园"],
    chapters: [
      { id: 1101, title: "第1话 一拳之缘", number: 1, updatedAt: "2026-07-30", views: 108000 },
      { id: 1102, title: "第2话 冤家路窄", number: 2, updatedAt: "2026-07-27", views: 102000 },
      { id: 1103, title: "第3话 心动瞬间", number: 3, updatedAt: "2026-07-24", views: 95000 },
    ],
    status: "连载中",
    views: 380000,
    rating: 9.0,
    updatedAt: "2026-07-30",
    tags: ["校园", "拳击", "喜剧", "浪漫"],
  },
  {
    id: 12,
    title: "末日的温度",
    author: "JUNG SEOK",
    cover: "https://readdy.ai/api/search-image?query=A%20poignant%20Korean%20post%20apocalyptic%20webtoon%20cover%20with%20two%20survivors%20holding%20hands%20in%20a%20ruined%20city%2C%20warm%20emotional%20lighting%20amidst%20darkness%2C%20clean%20composition%20on%20simple%20dark%20background%2C%20illustration&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20touching%20Korean%20webtoon%20scene%20of%20two%20survivors%20walking%20through%20a%20snow%20covered%20ruined%20cityscape%2C%20warm%20sunlight%20breaking%20through%20dark%20clouds%2C%20emotional%20atmosphere%2C%20illustration%20style&width=1200&height=600&seq=comic-hero-12&orientation=landscape",
    description: "末日之后，世界变成了冰封的荒原。两个陌生人在废墟中相遇，为了生存他们必须相互依靠。在这冰冷的世界里，他们能否守住彼此最后的温度？",
    categories: ["悬疑", "恋爱"],
    chapters: [
      { id: 1201, title: "第1话 冰封世界", number: 1, updatedAt: "2026-07-28", views: 95000 },
      { id: 1202, title: "第2话 废墟相遇", number: 2, updatedAt: "2026-07-25", views: 88000 },
      { id: 1203, title: "第3话 同行", number: 3, updatedAt: "2026-07-22", views: 82000 },
    ],
    status: "连载中",
    views: 350000,
    rating: 9.4,
    updatedAt: "2026-07-28",
    tags: ["末日", "生存", "温情", "冰雪"],
  },
];